export default __webpack_public_path__ + "static/media/cx.a2436c1f.svg";